export const hotelRoutes = {
    path: "hotel",
    name: "hotelFormview",
    alias: "/hotel",
    meta: { requiresAuth: true, title: 'Dreasyfly - Hotel Booking' },
    component: () => import('../views/hotelForm.vue'),
    children: [
        {
            path: "details",
            name: "hotelDetails",
            alias: "/details",
            component: () => import('../views/hotelSearchList.vue'),
        },
        {
            path: "bookingreport",
            name: "hotelBookingReport",
            alias: "/bookingreport",
            component: () => import('../views/hotelBookingReport.vue'),
        },
        {
            path: "refund-report",
            name: "hotelRefundReport",
            alias: "/refund-report",
            component: () => import('../views/hotelRefundReport.vue'),
        },
        {
            path: "cancellation-report",
            name: "hotelCancellationReport",
            alias: "/cancellation-report",
            component: () => import('../views/hotelCancellationView.vue'),
        },
        {
            path: "view-hotel-ticket/:transactionId?",
            name: "HotelTicketView",
            alias: "/view-hotel-ticket",
            component: () => import('../views/HotelTicketView.vue'),
        },
    ]
}
